<!-- 个人中心 > 组件的头部的公共组件 -->
<template>
  <div class="head">
    <div class="bar"/>
    <div class="title" :class="{ smallFont: small }">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'CommonHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      defaultValue: false
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  .bar {
    display: inline-block;
    width: 4px;
    height: 20px;
    margin-top: 2px;
    background: #EA5504;
    border-radius: 2px;
  }
  .title {
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    font-size: 18px;
    font-weight: 600;
  }
  .title.smallFont {
    font-weight: 400;
  }
}
</style>
